import { COMMON_IGNORED_ERRORS, shouldIgnoreError } from '@insta-club/utilities/sentry';
import * as Sentry from '@sentry/nextjs';

export function initSentryEdge() {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

        environment: process.env.NODE_ENV,
        enabled: process.env.NODE_ENV === 'production',
        debug: process.env.NODE_ENV === 'development',

        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
        enableLogs: true,
        sendDefaultPii: true,

        beforeSend(event, hint) {
            if (process.env.NODE_ENV !== 'production') {
                console.log('Sentry Edge Event (Dev):', event);
                return null;
            }

            if (shouldIgnoreError(hint.originalException, COMMON_IGNORED_ERRORS.edge)) {
                return null;
            }

            if (event.level !== 'error' && event.level !== 'fatal') {
                return null;
            }

            return event;
        },

        ignoreErrors: COMMON_IGNORED_ERRORS.edge
    });
}
